import React from 'react';

import { auth } from '../firebase';
import { Button } from '../styles/components';
export default () => (
  <Button type="button" onClick={() => auth.signOut()}>
    Sign Out
  </Button>
);
